import React, { useState } from "react";
import {
  CircularProgress,
  Paper,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import styled from "styled-components";
import API from "../../axios/instances/API";
import { mutate } from "swr";
import useGlobalStore from "src/store/useGlobalStore";

const Wrapper = styled(Paper)`
  padding: 20px;
  width: 500px;
  text-align: left;
  max-width: 520px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border: 2px solid black;
`;

const EditCompanyName = ({ handleClose, setSnackbarText }) => {
  const config = useGlobalStore((state) => state.config);
  const refetchConfigBackground = useGlobalStore(
    (state) => state.refetchConfigBackground,
  );
  const { read_only: readOnly } = config?.user;
  const [name, setName] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);

  const handleUpdate = async () => {
    setIsUpdating(true);
    try {
      await API.put("dashboard/company/details/", {
        name,
      });
      await refetchConfigBackground();
      mutate("dashboard/company/details/");
      setSnackbarText("Company name updated success");
      setIsUpdating(false);
      handleClose();
    } catch (error) {
      setSnackbarText(
        "There was an issue updating company name.. please try again. error",
      );
      setIsUpdating(false);
    }
  };

  return (
    <Wrapper>
      <Typography variant="h4" sx={{ mb: 4 }}>
        Edit Company Name
      </Typography>
      <TextField
        value={name}
        onChange={(e) => setName(e.currentTarget.value)}
        size="small"
        fullWidth
        sx={{ mb: 3 }}
        label="Enter new company name..."
        variant="outlined"
      />
      <Button
        variant="contained"
        color="primary"
        disabled={name.length < 2 || readOnly || isUpdating}
        fullWidth
        onClick={handleUpdate}
        startIcon={isUpdating ? <CircularProgress size={20} /> : null}
      >
        {isUpdating ? "Saving" : "Save"}
      </Button>
    </Wrapper>
  );
};

export default EditCompanyName;
